const VIEW_OPERATION_MATRIX = {
  front: {
    horizontalAxis: "x",
    verticalAxis: "y",
    horizontalSign: +1, // right = increase
    verticalSign: +1, // top = increase
    leftAlignEdge: "min", // min x1
    rightAlignEdge: "max", // max x2
  },
  right: {
    horizontalAxis: "z",
    verticalAxis: "y",
    horizontalSign: +1,
    verticalSign: +1,
    leftAlignEdge: "min", // min z1
    rightAlignEdge: "max", // max z2
  },
  left: {
    horizontalAxis: "z",
    verticalAxis: "y",
    horizontalSign: -1, // right = decrease (inverse)
    verticalSign: +1,
    leftAlignEdge: "max", // min z2 (inverse: max z1)
    rightAlignEdge: "min", // max z1 (inverse: min z2)
  },
  back: {
    horizontalAxis: "x",
    verticalAxis: "y",
    horizontalSign: -1,
    verticalSign: +1,
    leftAlignEdge: "max", // min x2 (inverse: max x1)
    rightAlignEdge: "min", // max x1 (inverse: min x2)
  },
  top: {
    horizontalAxis: "x",
    verticalAxis: "z",
    horizontalSign: +1,
    verticalSign: -1, // top = decrease (inverse)
    leftAlignEdge: "min", // min x1
    rightAlignEdge: "max", // max x2
  },
};

function getHorizontalDimension(rotation) {
  return [90, 270].includes(rotation) ? "depth" : "width";
}

function getVerticalDimension(rotation, cameraView) {
  if (cameraView !== "top") return "height";

  return [90, 270].includes(rotation) ? "width" : "depth";
}

function getViewOperationSpec(cameraView) {
  return VIEW_OPERATION_MATRIX[cameraView];
}

export { getViewOperationSpec, getHorizontalDimension, getVerticalDimension };
